import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { globals } from '../globals';
import { HttpClient } from '@angular/common/http';
import {
  CreateOrganizationRequest,
  CreatePaymentResponse,
  OctopusClient,
  OrganizationResponse,
  UpdateOrganizationRequest
} from '../hopper/octopus/client';
import { HopperOctopusConfiguration } from '../hopper';

@Injectable({
  providedIn: 'root'
})
export class OctopusService {
  constructor(
    public client: OctopusClient,
    private http: HttpClient,
    @Inject(HopperOctopusConfiguration)
    private _hopperConfigService: HopperOctopusConfiguration
  ) {}

  hasClient(): boolean {
    const config = this._hopperConfigService.getConfig();
    const { apiUrl } = config;

    return apiUrl !== undefined && apiUrl !== null && apiUrl !== '';
  }

  isConfigured(): boolean {
    const config = this._hopperConfigService.getConfig();
    const { apiUrl, clientId } = config;

    return (
      apiUrl !== undefined &&
      apiUrl !== null &&
      apiUrl !== '' &&
      clientId !== undefined &&
      clientId !== null &&
      clientId !== ''
    );
  }

  conectarEmpresa(organization: CreateOrganizationRequest): Observable<OrganizationResponse> {
    return this.http.post<OrganizationResponse>(globals.apiUrl + '/api/Octopus/ConectarEmpresa', organization);
  }

  atualizarEmpresa(organization: UpdateOrganizationRequest): Observable<OrganizationResponse> {
    return this.http.post<OrganizationResponse>(globals.apiUrl + '/api/Octopus/AtualizarEmpresa', organization);
  }

  desconectarEmpresa(): Observable<void> {
    return this.http.post<void>(globals.apiUrl + '/api/Octopus/DesconectarEmpresa', null);
  }

  criarPagamentoViaGateway(
    idCupom: string,
    idFinanca: number,
    userSchema: string,
    userModel: string
  ): Observable<CreatePaymentResponse> {
    return this.http.post<CreatePaymentResponse>(globals.apiUrl + '/api/Octopus/CriarPagamentoViaGateway', {
      idCupom,
      idFinanca,
      userSchema,
      userModel
    });
  }
}
